import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { AxiosError } from "axios";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

import { Button } from "@/components/ui/button/button";
import { useDeleteLeaveApplicationModal } from "./use-delete-leave-modal";
import { deleteLeaveApplicationAsAdmin } from "@/config/mutation/admin";

export const DeleteLeaveApplicationModal = () => {
  const queryClient = useQueryClient();
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, leaveId } = useDeleteLeaveApplicationModal();

  const { mutate, isPending } = useMutation({
    mutationFn: deleteLeaveApplicationAsAdmin(key),
  });

  const submitAction = async () => {
    mutate(
      {
        leaveId,
      },
      {
        onSuccess: async () => {
          // console.log("New Employee", data);
          await queryClient.invalidateQueries({
            queryKey: ["leave-applications"],
          });

          toast.success("Leave Application Deleted!");
          onOpenChange(false);
        },

        onError: (error) => {
          console.log("ERROR WHILE DELETING LEAVE REQUEST", error);
          const isAxiosError = error instanceof AxiosError;
          if (isAxiosError) {
            const errorReason = error?.response?.data?.error as string;
            toast.error(errorReason);
          } else {
            toast.error(error?.message);
          }
        },
      }
    );
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">
              Do you want to delete leave application request?
            </DialogTitle>
          </DialogHeader>

          <div className="flex items-center justify-end">
            <Button
              onClick={submitAction}
              disabled={isPending}
              variant="destructive"
            >
              Delete
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
